import { bindable } from 'aurelia-framework';
import flatpickr from 'flatpickr';

import 'flatpickr/dist/flatpickr.css';

export class DatePicker {
    @bindable value;
    @bindable disabled;

    attached () {
        flatpickr(this.input, {
            defaultDate: this.value != '0001-01-01T00:00:00Z' ? this.value : null,
            allowInput: true,
            dateFormat: "m/d/Y",
            onValueUpdate: (selectedDates, dateStr, instance) => {
                if (selectedDates.length > 0) {
                    this.value = selectedDates[0];
                }
            }
        });
    }
}
